import React from 'react';
import GovernanceInsights from '../../../components/governance/GovernanceInsights';
import GovernanceFrameworks from '../../../components/governance/GovernanceFrameworks';
import GovernanceProcesses from '../../../components/governance/mock/GovernanceProcesses';
import GovernancePrograms from '../../../components/governance/GovernancePrograms';
import GovernanceContracts from '../../../components/governance/mock/GovernanceContracts';
import GovernanceMeetingsNetbody from '../../../components/governance/GovernanceMeetingsNetBody';
// GovernanceMasters moved to Organisation → Masters tab (see OrgMasters).
import GovernanceTasks from '../../../components/governance/GovernanceTasks';
import CadenceRuleList from '../../../components/cadence/CadenceRuleList';
import { CADENCE_MODULE_TYPES } from '../../../components/cadence/cadenceModuleTypes';
import '../../../components/layout/ModuleLayout.css';
import { GovTabKey } from './GovernanceTabs';

interface GovernanceNetBodyProps {
  activeTab?: GovTabKey;
}

const GovernanceNetBody: React.FC<GovernanceNetBodyProps> = ({ activeTab = 'insights' }) => {
  const renderPanel = () => {
    if (activeTab === 'insights')   return <GovernanceInsights />;
    if (activeTab === 'frameworks') return <GovernanceFrameworks />;
    if (activeTab === 'sops')         return <GovernanceProcesses />;
    if (activeTab === 'sop-programs') return <GovernancePrograms />;
    if (activeTab === 'contracts')    return <GovernanceContracts />;
    if (activeTab === 'meetings')   return <GovernanceMeetingsNetbody />;
    if (activeTab === 'tasks')      return <GovernanceTasks />;
    if (activeTab === 'cadence')    return <CadenceRuleList allowedTypeCodes={CADENCE_MODULE_TYPES.governance} />;
    return null;
  };

  return (
    <div className="module-layout">
      <div className="module-main">
        <div className="tab-content">
          <section role="tabpanel" className="tab-panel show">
            {renderPanel()}
          </section>
        </div>
      </div>
    </div>
  );
};

export default GovernanceNetBody;
